











import { computed, defineComponent } from "@vue/composition-api";

export default defineComponent({
  props: {
    value: { type: Object },
    matches: { type: Array },
    selected: { type: Boolean, default: () => false }
  },
  setup(props) {
    const contextClasses = (
      context: Record<string, string>,
      prefix: string
    ) => [
      "",
      prefix,
      ...Object.entries(context).map(
        ([key, value]) => `${prefix}-${key}-${value}`
      )
    ];

    return {
      classes: computed(() =>
        [
          props.matches && props.matches.length > 0
            ? contextClasses(props.matches[0].context, "match")
            : [],
          props.selected ? ["evidence", "evidence-highlighted"] : []
        ].flat(1)
      )
    };
  }
});
